import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOverige = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M18 24c0-4.19 5.39-9.43 7.66-15.07a.36.36 0 0 1 .68 0C28.61 14.57 34 19.81 34 24a8 8 0 0 1-16 0"
    />
    <path
      fill="#FFBFA5"
      d="M17.85 16.92c3.34 3.34 4.13 8.25 1.43 11s-7.58 2.13-10.91-1.2z"
    />
    <path
      fill="#FF7842"
      d="M7.58 17.67a.51.51 0 0 1 .92.33 4.46 4.46 0 0 0 2.13 3.48S8 12.76 14.38 8.6a.4.4 0 0 1 .6.45 4.63 4.63 0 0 0 1.41 4.71c2.86 2.85 6.65 4.76 6.72 9.46A8.51 8.51 0 0 1 16 31.88a8.63 8.63 0 0 1-10.17-8.52 11.4 11.4 0 0 1 1.75-5.69m5.3 8.33a6.1 6.1 0 0 1-2.15 1.08.581.581 0 0 0-.16 1 6.28 6.28 0 1 0 6.88-10.47 6.27 6.27 0 0 1-3 8.86 4.22 4.22 0 0 0 .75-4.23A6.25 6.25 0 0 1 12.88 26M31.68 21.15a6 6 0 0 0-2.58-2.1.65.65 0 0 0-.7 1.07c.382.353.718.753 1 1.19a6 6 0 0 1-1 7.64.65.65 0 0 0 .7 1.05 6 6 0 0 0 2.58-8.87z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M32.807 28.217a7.3 7.3 0 0 0 .573-2.8l1 .006a8.3 8.3 0 0 1-8.385 8.257l.01-1a7.3 7.3 0 0 0 6.802-4.463M15.233 10.727a7 7 0 0 1 1.514-2.261l.706.708a5.96 5.96 0 0 0 0 8.442l-.706.708a6.96 6.96 0 0 1-1.514-7.598M6.807 17.73a5.4 5.4 0 0 1 1.192-1.766l.702.712a4.42 4.42 0 0 0 0 6.288L8 23.676a5.42 5.42 0 0 1-1.192-5.945"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOverige);

export default ForwardRef;
